import type { GetTicketReqData, GetTicketResData } from '~/types/ticket'

import { publicApi } from './api'

const getTicket = async (reqData: GetTicketReqData): Promise<GetTicketResData> => {
  const response = await publicApi.post<GetTicketResData>('queue-request', reqData)

  return response.data
}

export default { getTicket }
